import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { NewStrategyForm } from '@/components'
import { botApi } from './api'

export default function BotNew() {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const navigate = useNavigate()

  const handleSubmit = async (prompt: string) => {
    setIsSubmitting(true)
    setError(null)

    try {
      const result = await botApi.create(prompt)
      console.log('Bot created:', result)
      navigate(`/strategy/${result.bid}`)
    } catch (err) {
      console.error('Error creating bot:', err)
      setError('Failed to create bot. Please try again.')
      setIsSubmitting(false)
    }
  }

  return (
    <NewStrategyForm
      heading="What strategy would you like to build today?"
      subheading="Describe your trading idea in plain English. We'll generate, backtest and optimise it for you."
      badgeLabel="AI-powered algo strategy builder"
      placeholder="e.g. Short term scalping strategy on EURUSD using moving averages on H1 with 1% risk..."
      submitLabel="Build Strategy"
      isSubmitting={isSubmitting}
      error={error}
      onSubmit={handleSubmit}
    />
  )
}
